import React from 'react';
import SupportTicketsPanel from './support/SupportTicketsPanel';

// Partner settings › Support: the partner's queue — tickets about the partner, its chains and its hotels — through the
// shared ticket list (support/SupportTicketsPanel). A ticket's status is the support team's; a superadmin sets one by
// hand only on a ticket from before the move, on the ticket's own page.
const PartnerSupportTickets = ({ partnerId }) => (
    <SupportTicketsPanel scope="partner" partnerId={partnerId} emptyText="No support tickets for this partner yet" />
);

export default PartnerSupportTickets;
